import { lazy, Suspense, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Div100vh from "react-div-100vh";
import { useSelector } from "react-redux";
import * as Sentry from "@sentry/react";

import "./App.css";
import routes from "./routes";
import withClearCache from "./hoc/withClearCache";
import RenderAppRoutes from "components/RenderAppRoutes";
import {
  WEBAPP_THEME_MODE_DARK,
  WEBAPP_THEME_MODE_LIGHT,
} from "utils/constants";
import { handleNotificationPermission } from "./firebase";
import { getBrowserNotifPermissionState } from "utils/browserNotifs";
import { FCM_TOKEN_KEY } from "constants/localStorageKeys";

// const ConversationsPage = lazy(() => import("./pages/conversation"));
// const ForgetPasswordCard = lazy(() => import("components/ForgetPasswordCard"));
const OneTimeVerification = lazy(() => import("pages/oneTimeVerification"));
const LoginPage = lazy(() => import("./pages/login"));
// const ForgetPasswordPage = lazy(() => import("./pages/forgetPassword"));

const mapState = (state) => state.settingsData.locale;
const getAgent = ({ userData }) => userData.agent.data;
const getIsLoggedInUser = ({ authData }) => authData.isLoggedInUser;

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

function App() {
  const locale = useSelector(mapState);
  const agent = useSelector(getAgent);
  const isLoggedInUser = useSelector(getIsLoggedInUser);

  useEffect(() => {
    const notifState = getBrowserNotifPermissionState();

    if (!notifState) {
      console.log("Notification is not supported");
      return;
    }

    const storedFcmToken = localStorage.getItem(FCM_TOKEN_KEY);

    if ((storedFcmToken && notifState === "granted") || !isLoggedInUser) return;

    if (notifState === "granted" && !storedFcmToken) {
      handleNotificationPermission(false, locale);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedInUser]);

  useEffect(() => {
    if (locale === "fa") {
      document.title = "اپلیکیشن تحت وب رایچت";
      document.querySelector("html").setAttribute("lang", "fa");
      document.querySelector("body").setAttribute("dir", "rtl");
      localStorage.setItem("raychat_web_app_locale", "fa");
    } else {
      document.title = "Raychat Web Application";
      document.querySelector("html").setAttribute("lang", "en");
      document.querySelector("body").setAttribute("dir", "ltr");
      localStorage.setItem("raychat_web_app_locale", "en");
    }
  }, [locale]);

  useEffect(() => {
    if (!!agent?.appStyle) {
      const t =
        agent?.appStyle === "2"
          ? WEBAPP_THEME_MODE_DARK
          : WEBAPP_THEME_MODE_LIGHT;

      document.querySelector("body").setAttribute("theme", t);
    } else {
      // default to "light" theme
      document
        .querySelector("body")
        .setAttribute("theme", WEBAPP_THEME_MODE_LIGHT);
    }
  }, [agent?.appStyle]);

  return (
    <div className="App">
      <Div100vh style={{ width: "100%", display: "flex" }}>
        <Suspense fallback={<></>}>
          <SentryRoutes>
            <Route path={"/*"} element={<RenderAppRoutes />} />
            <Route path={routes.login} element={<LoginPage />} />
            {/* <Route
              path={routes.forgetPassword}
              element={<ForgetPasswordPage />}
            /> */}
            <Route
              path={routes.oneTimeVerification}
              element={<OneTimeVerification />}
            />
          </SentryRoutes>
        </Suspense>
      </Div100vh>
    </div>
  );
}

export default withClearCache(App);
